import React from 'react'
import {
  GET_TENANT_PARKING_POOL_CONFIG,
  IGetTenantParkingPoolConfigData,
  IGetTenantParkingPoolConfigVars,
} from '../../graphql/tenant/getTenantParkingPoolConfig'
import { useQuery } from '@apollo/client'
import { Box, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../redux/store'
import { colors } from '../../const/colors'

const NoPlacesAssignedAlert = () => {
  const { t } = useTranslation(['parking_pool_data'])
  const { tenantName } = useAppSelector(state => state.user)
  const { data, loading } = useQuery<
    IGetTenantParkingPoolConfigData,
    IGetTenantParkingPoolConfigVars
  >(GET_TENANT_PARKING_POOL_CONFIG, {
    fetchPolicy: 'cache-and-network',
    variables: { name: tenantName },
  })

  if (loading || data?.getTenant?.parkingPool?.isValid) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        alignItems: 'flex-start',
        mb: '16px',
        p: '14px 16px',
        borderRadius: '12px',
        background: colors.redBg,
        border: `1px solid ${colors.redBorder}`,
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: '9px',
          background: colors.red,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 18, color: '#fff' }} />
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: '13.5px',
            fontWeight: 700,
            color: colors.red,
            lineHeight: 1.4,
          }}
        >
          {t('no_valid')}
        </Typography>
        <Typography
          sx={{
            fontSize: '12.5px',
            color: colors.red,
            opacity: 0.8,
            lineHeight: 1.55,
            mt: '3px',
          }}
        >
          {t('no_valid_desc')}
        </Typography>
      </Box>
    </Box>
  )
}

export default NoPlacesAssignedAlert
